import {
    AfterViewInit,
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core"
import { DataPrivacyAcknowledgmentComponent } from "./data-privacy-acknowledgment/data-privacy-acknowledgment.component"
import { DataPrivacyClassroomComponent } from "./data-privacy-classroom/data-privacy-classroom.component"
import { FormGroup } from "@angular/forms"
import { BehaviorSubject, Subject } from "rxjs"
import { UserDataPrivacyService } from "../../../services/user-data-privacy.service"
import { takeUntil } from "rxjs/operators"
import { UserDataPrivacyPayload } from "../../../models/userDataPrivacy.model"

@Component({
    selector: "app-data-privacy-select",
    templateUrl: "./data-privacy-select.component.html",
    styleUrls: ["./data-privacy-select.component.scss"],
})
export class DataPrivacySelectComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataPrivacyAcknowledgmentComponent)
    dataPrivacyAcknowledgmentRef: DataPrivacyAcknowledgmentComponent

    @ViewChild(DataPrivacyClassroomComponent)
    dataPrivacyClassroomRef: DataPrivacyClassroomComponent

    @Output()
    submitBtnClicked = new EventEmitter<UserDataPrivacyPayload>()

    isFormInvalid = true
    form = new FormGroup({})

    private destroyed$ = new Subject()

    isLoading = new BehaviorSubject<boolean>(false)

    constructor(private userDataPrivacyService: UserDataPrivacyService) {}

    ngOnInit(): void {
        this.form.statusChanges
            .pipe(takeUntil(this.destroyed$))
            .subscribe((formStatus) => (this.isFormInvalid = formStatus === "INVALID"))
    }

    ngAfterViewInit(): void {
        this.form.addControl("privacyCheck", this.dataPrivacyAcknowledgmentRef.privacyCheckControl)
        this.form.addControl("classRoomSetting", this.dataPrivacyClassroomRef.classRoom)
    }

    ngOnDestroy(): void {
        this.destroyed$.next()
        this.destroyed$.complete()
    }

    onSubmit(): void {
        const payload = this.userDataPrivacyService.createPayload(this.form.value)
        this.submitBtnClicked.next(payload)
    }
}
